import React, { useEffect, useReducer } from 'react';
import { useForm } from 'react-hook-form';
// import { useHistory, useParams } from 'react-router';
import { useNavigate , useParams  } from 'react-router-dom';
import { ImageUpload } from '../common';
import { disciplineService } from './disciplineService';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    discipline: undefined,
    uploadImage: undefined,
    uploadThumbnail: undefined
}

const ACTIONS = {
    DISCIPLINE_GET_CALL: 'DISCIPLINE_GET_CALL',
    DISCIPLINE_GET_SUCCESS: 'DISCIPLINE_GET_SUCCESS',
    DISCIPLINE_GET_ERROR: 'DISCIPLINE_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    UPDATE_UPLOAD_IMAGE: 'UPDATE_UPLOAD_IMAGE',
    UPDATE_UPLOAD_THUMBNAIL: 'UPDATE_UPLOAD_THUMBNAIL',
    DISCIPLINE_UPDATE_CALL: 'DISCIPLINE_UPDATE_CALL',
    DISCIPLINE_UPDATE_SUCCESS: 'DISCIPLINE_UPDATE_SUCCESS',
    DISCIPLINE_UPDATE_ERROR: 'DISCIPLINE_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.DISCIPLINE_GET_CALL:
            return {
                ...state, 
                isLoading: true
            }
        case ACTIONS.DISCIPLINE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                discipline: {
                    ...action.data
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting,
                uploadImage: isEditting ? state.uploadImage : undefined,
                uploadThumbnail: isEditting ? state.uploadThumbnail : undefined
            }
        case ACTIONS.UPDATE_UPLOAD_IMAGE:
            return {
                ...state,
                uploadImage: action.data
            }
        case ACTIONS.UPDATE_UPLOAD_THUMBNAIL:
            return {
                ...state,
                uploadThumbnail: action.data
            }
        case ACTIONS.DISCIPLINE_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: false
            }
        case ACTIONS.DISCIPLINE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                discipline: {
                    ...action.data
                }
            }
        case ACTIONS.DISCIPLINE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function DisciplineEdit() {

    const { disciplineId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    // const history = useHistory();
    const navigate = useNavigate();
    const {contextValue} = useAuth();

    useEffect(() => {
        dispatch({ type: ACTIONS.DISCIPLINE_GET_CALL });
        disciplineService.getDiscipline(disciplineId)
        .then(response => dispatch({ type: ACTIONS.DISCIPLINE_GET_SUCCESS, data: response.data }))
        .catch(error => console.error(error)); 
    }, [disciplineId]);

    useEffect(() => {
        if (state.discipline || !state.isEditting) {
            reset({discipline: state.discipline});
        }
    }, [state.discipline, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();

        const message = `This will permanently delete the record for ${state.discipline.name}, and any asscoiated records such as competitions. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting discipline...");

                disciplineService.deleteDiscipline(disciplineId).then(response => {
                    toast.success(`${state.discipline.name} has been deleted.`);
                    navigate('/discipline');
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Error deleting discipline");
                })
                .finally(() => contextValue.hideLoader());

              // delete logic here
            }
          });


        //   return;
        // if (window.confirm(`This will permanently delete the record for ${state.discipline.name}, and any asscoiated records such as competitions. There is no way to undo this action. Press 'Ok' if you are sure you want to delete ${state.discipline.name}.`)) {
        //     disciplineService.deleteDiscipline(disciplineId);
        //     window.alert(`${state.discipline.name} has been deleted.`);
        //     // history.push('/discipline');
        //     navigate('/discipline');
        // }
    }

    function handleSaveClick({discipline}) {

        contextValue.showLoader();
        contextValue.updateLoaderText("Updating discipline...");
        dispatch({ type: ACTIONS.DISCIPLINE_UPDATE_CALL });
        disciplineService.updateDiscipline(disciplineId, {
            ...discipline,
            image: state.uploadImage,
            thumbnail: state.uploadThumbnail
        })
        .then(response => {
            dispatch({ type: ACTIONS.DISCIPLINE_UPDATE_SUCCESS, data: response.data })
            toast.success("Discipline updated successfully");
        })
        .catch(error => {
            toast.error("Error updating discipline");
            dispatch({ type: ACTIONS.DISCIPLINE_UPDATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());
    }

    function handleImageUpload(image) {
        dispatch({ type: ACTIONS.UPDATE_UPLOAD_IMAGE, data: image});
    }

    function handleThumbnailUpload(thumbnail) {
        dispatch({ type: ACTIONS.UPDATE_UPLOAD_THUMBNAIL, data: thumbnail});
    }

    function renderDisciplineImage() {
        let src;
        if (state.uploadImage) {
            src = URL.createObjectURL(state.uploadImage);
        } else if (state.discipline.imagePath) {
            src = `${process.env.REACT_APP_MEDIA_HOST}/${state.discipline.imagePath}`;
        } else {
            src = '/images/horse_image_default.jpg'
        }


        if(state.discipline.thumbnailPath) {
            src = `${process.env.REACT_APP_AWS_S3}${state.discipline.imagePath}`;
        }
        console.log(src);

        return (
            <img className='m-auto mb-3 w-100 rounded-3' src={src} alt=''/>
        );
    }

    function renderDisciplineThumbnail() {
        let src;
        if (state.uploadThumbnail) {
            src = URL.createObjectURL(state.uploadThumbnail);
        } else if (state.discipline.thumbnailPath) {
            src = `${process.env.REACT_APP_MEDIA_HOST}/${state.discipline.thumbnailPath}`;
        } else {
            src = '/images/horse_image_default.jpg'
        }

        if(state.discipline.thumbnailPath) {
            src = `${process.env.REACT_APP_AWS_S3}${state.discipline.thumbnailPath}`;
        }

        return (
            <img className='m-auto mb-3 w-100 rounded-3' src={src} alt=''/>
        );
    }


    return (
        <div className='container h-100 overflow-auto'>
        {!state.isLoading &&
            <form>
                <div className='row mb-3'>
                    <h2 className='col'>{state.discipline.name}</h2>
                    {!state.isEditting &&
                        <div className='col-auto'>
                            <button className='btn btn-primary me-2' onClick={handleEditClick}>Edit</button>
                            <button className='btn btn-danger text-white' onClick={handleDeleteClick}>Delete</button>
                        </div>
                    }
                    {state.isEditting &&
                        <div className='col-auto'>
                            <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                            <button className='btn btn-primary' onClick={handleEditClick}>Cancel</button>
                        </div>
                    }
                </div>
                <div className="row">
                    <div className='col-sm col-lg-auto mb-3'>
                        <div className='picture-container m-auto'>
                            <label className='form-label'>Image:</label>
                            {renderDisciplineImage()}
                            {state.isEditting &&
                                <button type='button' className='btn btn-primary w-100' data-bs-toggle='modal' data-bs-target='#imageUpload'>
                                    Upload Image
                                </button>
                            }
                            <ImageUpload id='imageUpload' aspectRatio={0.8} onUpload={handleImageUpload}/>
                            <label className='form-label'>Thumbnail:</label>
                            {renderDisciplineThumbnail()}
                            {state.isEditting &&
                                <button type='button' className='btn btn-primary w-100' data-bs-toggle='modal' data-bs-target='#thumbnailUpload'>
                                    Upload Thumbnail
                                </button>
                            }
                            <ImageUpload id='thumbnailUpload' aspectRatio={1} onUpload={handleThumbnailUpload}/>
                        </div>
                    </div>
                    <div className='col-lg'>
                        <div className='row'>
                            <div className='col'>
                                <label htmlFor='disciplineName' className='form-label'>Name:</label>
                                <input type='text' className='form-control' id='disciplineName' autoComplete='off' {...register('discipline.name', {required: true})} disabled={!state.isEditting}/>
                                {errors.discipline?.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        }
    </div>
    );
}

export default DisciplineEdit;